// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".node_modules-\\@vibrent-electryon-dist-components-overlay-styles__overlay-tooltip-action--JIjh4gNa{position:relative}.node_modules-\\@vibrent-electryon-dist-components-overlay-styles__overlay-tooltip-action--JIjh4gNa .action-btn-tooltip{position:absolute;opacity:1;border-radius:2px;background-color:#4c4c4c;font-size:11px;line-height:24px;padding:2px 6px}.node_modules-\\@vibrent-electryon-dist-components-overlay-styles__overlay-tooltip-action--JIjh4gNa .action-btn-tooltip .tooltip-content{color:#fff;transition:.5s linear}", ""]);
// Exports
exports.locals = {
	"overlay-tooltip-action": "node_modules-@vibrent-electryon-dist-components-overlay-styles__overlay-tooltip-action--JIjh4gNa"
};
module.exports = exports;
